import type { Conflict, DecideConflict, Dispute } from '@cyberscore/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useSession } from '../../lib/session';

/** Answers the internet check contradicts (task 72). */

const key = (t?: string) => ['conflicts', t] as const;

export function useConflicts(state: 'open' | 'settled') {
  const { tenant } = useSession();
  return useQuery({ queryKey: [...key(tenant?.id), 'book', state], queryFn: () => api<Conflict[]>('GET', `/conflicts?state=${state}`), enabled: !!tenant }); // prettier-ignore
}

export function useAssessmentConflicts(id: string) {
  const { tenant } = useSession();
  return useQuery({ queryKey: [...key(tenant?.id), 'assessment', id], queryFn: () => api<Conflict[]>('GET', `/assessments/${id}/conflicts`), enabled: !!tenant }); // prettier-ignore
}

export function useConflictActions() {
  const qc = useQueryClient();
  const { tenant } = useSession();
  const done = () => {
    void qc.invalidateQueries({ queryKey: key(tenant?.id) });
    // Confirming changes the answer and the score.
    void qc.invalidateQueries({ queryKey: ['assessments', tenant?.id] });
  };
  return {
    dispute: useMutation({ mutationFn: ({ id, ...body }: Dispute & { id: string }) => api<Conflict>('POST', `/conflicts/${id}/dispute`, body), onSuccess: done }), // prettier-ignore
    decide: useMutation({ mutationFn: ({ id, ...body }: DecideConflict & { id: string }) => api<Conflict>('POST', `/conflicts/${id}/decide`, body), onSuccess: done }), // prettier-ignore
  };
}
